export default __webpack_public_path__ + "static/media/logo4.749ed15d.jpg";